import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import "./home.styles.css";

function HomeMainSection() {
  return (
    <Box className="home__content">
      <div className="home__content--title">
        <Typography
          sx={{
            fontFamily:"Roboto-serif",
            fontSize:"20px",
            color:"#fff",
            fontWeight:"600",
            textTransform:"uppercase"
          }}
        >
          Welcome To NBA Player's Portal
        </Typography>
        <Typography
          sx={{
            fontFamily:"Roboto-serif",
            fontSize:"14px",
            color:"#acaac6",
            fontWeight:"400",
            
          }}
        >
          <i>Choose "CHECK PLAYER RANK" to check your rank.</i>
        </Typography>
      </div>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        // gap="3rem"
        justifyContent="center"
        alignItems="center"
        sx={{
          gap:{xs:"1rem",sm:"3rem"}
        }}
        // className="home__content--buttons"
      >
        <Link
          to="register"
          className="home__content--buttons_button1 home__content--buttons_button"
        >
          PLAYER LIST(NBA only)
        </Link>
        <Link
          to="playerranking"
          className="home__content--buttons_button2 home__content--buttons_button"
        >
          CHECK PLAYER RANK
        </Link>
      </Box>
    </Box>
  );
}

export default HomeMainSection;
